import { ValidationStrategy } from "./validation.strategy";

export class NoValidationStrategy extends ValidationStrategy {

    public validate(): boolean {
        return true
    }
}